<div class="tw-mt-5" *ngIf="!isLoading">
  <ng-container *ngIf="!provisional && portfolioListModel && portfolioListModel.length > 0">
    <!-- Search -->
    <div class="tw-mb-4">
      <search-input
        [placeholder]="'portfolio.searchCompany'"
        [value]="searchTerm"
        [showClear]="true"
        (onSubmit)="onSearch($event)"
      ></search-input>
    </div>

    <!-- No matching holdings for the current search -->
    <div class="col-12 text-center tw-py-20" *ngIf="displayedPortfolio.length === 0">
      {{ 'common.noRecord' | translate }}
    </div>

    <!-- Desktop table -->
    <div
      class="p-table__wrapper max-md:tw-hidden"
      *ngIf="groupedPortfolio.length > 0"
    >
      <div class="p-table__body">
        <mat-table class="responsive-table p-table" [dataSource]="visibleGroupedPortfolio">
          <ng-container matColumnDef="Company">
            <mat-header-cell *matHeaderCellDef class="tw-whitespace-nowrap">{{
              'mysec.companyAndCounter' | translate
            }}</mat-header-cell>
            <mat-cell *matCellDef="let item">
              <!-- Counter child row: nested under its company — vertical connector line, no logo -->
              <div *ngIf="item.isCounterChild" class="tw-flex tw-w-full tw-items-stretch tw-self-stretch">
                <span
                  class="tw-ml-[30px] tw-mr-7 tw-w-[3px] tw-shrink-0 tw-bg-table"
                  aria-hidden="true"
                ></span>
                <div class="tw-min-w-0 tw-self-center tw-py-1">
                  <div class="tw-font-bold tw-uppercase tw-text-sm tw-text-body-dark">
                    {{ item.tickerCode }}
                  </div>
                  <a
                    [routerLink]="['/pstx', item.tickerCode]"
                    *ngIf="
                      item.tickerCode &&
                      item.status !== ShareMarketStatus.Dehosting &&
                      item.status !== ShareMarketStatus.Inactive
                    "
                    class="p-link-secondary tw-text-xs"
                  >
                    <span>{{ 'mysec.buyMore' | translate }}</span> →
                  </a>
                </div>
              </div>

              <!-- Company row: single counter, or aggregate parent (with expand/collapse) -->
              <ng-container *ngIf="!item.isCounterChild">
                <div class="tw-flex tw-items-center tw-gap-1">
                  <!-- Aggregate rows get an expand/collapse toggle; single companies get an
                       empty gutter of the same width so their logos line up. -->
                  <button
                    *ngIf="item.isAggregate"
                    type="button"
                    class="btn-transparent tw-shrink-0 tw-p-0 tw-text-light-grey"
                    [attr.aria-expanded]="isCompanyExpanded(item.companyGroupKey)"
                    [attr.aria-label]="
                      (isCompanyExpanded(item.companyGroupKey)
                        ? ('portfolio.collapseCounters' | translate)
                        : ('portfolio.expandCounters' | translate)) +
                      ' ' +
                      (item?.company?.brandName || '')
                    "
                    (click)="toggleCompany(item, $event)"
                  >
                    <span
                      class="tw-inline-block tw-origin-center tw-transform tw-transition-transform"
                      [class.-tw-rotate-90]="!isCompanyExpanded(item.companyGroupKey)"
                    >
                      <p-icon name="chevron-down"></p-icon>
                    </span>
                  </button>
                  <span *ngIf="!item.isAggregate" class="tw-w-6 tw-shrink-0" aria-hidden="true"></span>

                  <ng-container
                    *ngIf="
                      !item.isAggregate &&
                        item.tickerCode &&
                        item.status !== ShareMarketStatus.Dehosting;
                      else companyStatic
                    "
                  >
                    <div
                      class="cursor-pointer tw-min-w-0 tw-flex-1"
                      [routerLink]="['/pstx', item.tickerCode]"
                    >
                      <ng-container
                        *ngTemplateOutlet="companyName; context: { item: item }"
                      ></ng-container>
                    </div>
                  </ng-container>
                  <ng-template #companyStatic>
                    <div
                      class="tw-min-w-0 tw-flex-1"
                      [class.cursor-pointer]="item.isAggregate"
                      (click)="item.isAggregate && toggleCompany(item)"
                    >
                      <ng-container
                        *ngTemplateOutlet="companyName; context: { item: item }"
                      ></ng-container>
                    </div>
                  </ng-template>
                </div>
              </ng-container>

              <ng-template #companyName let-item="item">
                <app-thumbnail-group
                  [name]="item?.company?.brandName"
                  [description]="
                    item.isAggregate
                      ? (item.counterCount || 0) + ' ' + ('portfolio.counters' | translate)
                      : item.tickerCode
                        ? item?.tickerCode.toUpperCase()
                        : null
                  "
                  [imageUrl]="item?.company?.companyLogoUrl"
                >
                </app-thumbnail-group>

                <div class="tw-mt-1 tw-pl-[50px]" *ngIf="!item.isAggregate">
                  <a
                    [routerLink]="['/pstx', item.tickerCode]"
                    *ngIf="
                      item.tickerCode &&
                      item.status !== ShareMarketStatus.Dehosting &&
                      item.status !== ShareMarketStatus.Inactive
                    "
                    class="p-link-secondary tw-text-xs max-md:tw-hidden"
                  >
                    <span>{{ 'mysec.buyMore' | translate }}</span> →
                  </a>
                </div>
              </ng-template>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="TickerCode">
            <mat-header-cell *matHeaderCellDef>
              <span class="d-flex align-items-center">
                {{ 'Counter' | translate }}
                <button
                  type="button"
                  #tooltip="matTooltip"
                  (click)="tooltip.toggle()"
                  class="btn-transparent"
                  matTooltip="{{ 'portfolio.tickerCodeDesc' | translate }}"
                >
                  <div class="pitchin-icon pitchin-icon-help-circle p-help-icon"></div>
                </button>
              </span>
            </mat-header-cell>

            <mat-cell *matCellDef="let item">
              <ng-container
                *ngIf="
                  item.tickerCode &&
                  item.status !== ShareMarketStatus.Dehosting &&
                  item.status !== ShareMarketStatus.Inactive
                "
              >
                <a
                  [routerLink]="['/pstx', item.tickerCode]"
                  class="p-link-underline p-link-primary tw-uppercase"
                  >{{ item.tickerCode }}</a
                >
              </ng-container>
              <ng-container
                *ngIf="
                  item.tickerCode &&
                  (item.status === ShareMarketStatus.Dehosting ||
                    item.status === ShareMarketStatus.Inactive)
                "
              >
                <div class="tw-uppercase">{{ item.tickerCode }}</div>
              </ng-container>
              <ng-container *ngIf="!item.tickerCode">
                <div class="p-text-tag--round p-text-tag--dot">
                  {{ 'common.pending' | translate }}
                </div>
              </ng-container>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="ShareQty">
            <mat-header-cell *matHeaderCellDef>{{
              'portfolio.shareQty' | translate
            }}</mat-header-cell>
            <mat-cell
              *matCellDef="let item"
              [ngClass]="'tw-flex tw-justify-between tw-gap-2 tw-tabular-nums'"
            >
              <ng-container *ngTemplateOutlet="shareQty; context: { item: item }"></ng-container>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="Ownership">
            <mat-header-cell *matHeaderCellDef>
              {{ 'portfolio.ownership' | translate }}
              <button
                type="button"
                #tooltip="matTooltip"
                (click)="tooltip.toggle()"
                class="btn-transparent"
                matTooltip="{{ 'portfolio.ownershipTooltip' | translate }}"
              >
                <div class="pitchin-icon pitchin-icon-help-circle p-help-icon"></div>
              </button>
            </mat-header-cell>
            <mat-cell *matCellDef="let item">
              <div class="tw-flex tw-flex-wrap tw-gap-1">
                <div
                  class="p-text-tag--round p-tag--info"
                  *ngIf="
                    [ShareOwnership.Direct, ShareOwnership.Both].includes(item.portfolio?.ownership)
                  "
                >
                  {{ 'portfolio.Direct' | translate }}
                </div>
                <div
                  class="p-text-tag--round p-tag--warning"
                  *ngIf="
                    [ShareOwnership.Nominee, ShareOwnership.Both].includes(
                      item.portfolio?.ownership
                    )
                  "
                >
                  {{ 'portfolio.Nominee' | translate }}
                </div>
              </div>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="PurchasedPrice">
            <mat-header-cell *matHeaderCellDef [ngClass]="'tw-justify-end'">
              {{ 'portfolio.costBasis' | translate }}
              <button
                type="button"
                #tooltipInvest="matTooltip"
                (click)="tooltipInvest.toggle()"
                class="btn-transparent !tw-pr-0"
                matTooltip="{{ 'portfolio.investedAmountTooltip' | translate }}"
              >
                <div class="pitchin-icon pitchin-icon-help-circle p-help-icon"></div>
              </button>
            </mat-header-cell>
            <mat-cell
              *matCellDef="let item"
              [ngClass]="'tw-justify-end tw-text-right tw-tabular-nums'"
            >
              <ng-container
                *ngTemplateOutlet="investmentAmount; context: { item: item }"
              ></ng-container>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="MarketPrice">
            <mat-header-cell *matHeaderCellDef [ngClass]="'tw-justify-end'">
              {{ 'portfolio.marketValue' | translate }}
              <button
                type="button"
                #tooltipMarket="matTooltip"
                (click)="tooltipMarket.toggle()"
                class="btn-transparent !tw-pr-0"
                matTooltip="{{ 'portfolio.totalMarketValueTooltip' | translate }}"
              >
                <div class="pitchin-icon pitchin-icon-help-circle p-help-icon"></div>
              </button>
            </mat-header-cell>
            <mat-cell
              *matCellDef="let item"
              [ngClass]="'tw-flex-col tw-items-end tw-justify-center tw-gap-1 tw-text-right tw-tabular-nums'"
            >
              <ng-container *ngTemplateOutlet="marketPrice; context: { item: item }"></ng-container>
              <!-- PLT-1394 hide valuation basis when counter is pending or dehosted, also if no new updatedPrice, don't show -->
              <div
                *ngIf="
                  item.tickerCode &&
                  item.status !== ShareMarketStatus.Dehosting &&
                  item.portfolio?.indicativeSharePrice !== 0 &&
                  item.portfolio?.valuationBasis !== undefined
                "
              >
                <button
                  type="button"
                  class="p-link-secondary tw-text-xs max-xl:tw-text-xxs"
                  (click)="openValuationBasisPopup(item)"
                >
                  {{ 'mysec.valuationBasis' | translate }} →
                </button>
              </div>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="Profit">
            <mat-header-cell *matHeaderCellDef [ngClass]="'tw-justify-end'">
              {{ 'portfolio.totalGainLoss' | translate }}
              <button
                type="button"
                #tooltipGain="matTooltip"
                (click)="tooltipGain.toggle()"
                class="btn-transparent !tw-pr-0"
                matTooltip="{{ 'portfolio.unrealisedGainLossTooltip' | translate }}"
              >
                <div class="pitchin-icon pitchin-icon-help-circle p-help-icon"></div>
              </button>
            </mat-header-cell>
            <mat-cell
              *matCellDef="let item"
              [ngClass]="'tw-flex-col tw-items-end tw-justify-center tw-gap-1 tw-tabular-nums'"
            >
              <ng-container
                *ngTemplateOutlet="gainLossDesktop; context: { item: item }"
              ></ng-container>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="Action">
            <mat-header-cell *matHeaderCellDef>
              {{ 'common.actions' | translate }}
            </mat-header-cell>
            <mat-cell
                      *matCellDef="let item"
                      [ngClass]="'tw-flex-col tw-items-start tw-justify-center tw-gap-2.5'"
                      >
                <!-- Actions live on counter / single rows, not the company aggregate row -->
                <ng-container *ngIf="!item.isAggregate">
                    <!-- View company -->
                    <a
                       *ngIf="
                         item.tickerCode &&
                         item.status !== ShareMarketStatus.Dehosting &&
                         item.status !== ShareMarketStatus.Inactive
                       "
                       [routerLink]="['/pstx', item.tickerCode]"
                       class="btn-transparent p-link-secondary tw-text-xs max-xl:tw-text-xxs">
                        {{ 'portfolio.viewCompany' | translate }} →
                    </a>
                    <a
                       *ngIf="
                         !(
                           item.tickerCode &&
                           item.status !== ShareMarketStatus.Dehosting &&
                           item.status !== ShareMarketStatus.Inactive
                         )
                       "
                       [routerLink]="['/company']"
                       [queryParams]="{ companyId: item.portfolio?.companyId }"
                       (click)="$event.stopPropagation()"
                       class="btn-transparent p-link-secondary tw-text-xs max-xl:tw-text-xxs">
                        {{ 'portfolio.viewCompany' | translate }} →
                    </a>

                    <!-- Download digital cert -->
                    <ng-container *ngIf="item.digitalCert && item.digitalCert?.url">
                        <button
                                type="button"
                                class="btn-transparent p-link-secondary tw-p-0 tw-text-xs max-xl:tw-text-xxs max-xl:!tw-whitespace-normal"
                                (click)="openUrl(item.digitalCert?.url)"
                                >
                            {{ 'portfolio.downloadDigitalCert' | translate }} →
                        </button>
                    </ng-container>
                </ng-container>
            </mat-cell>
          </ng-container>
          <mat-header-row *matHeaderRowDef="displayColumns"> </mat-header-row>
          <mat-row *matRowDef="let item; columns: displayColumns" [ngClass]="item.newlyImported ? 'tw-border !tw-border-[#c8e9d6] tw-bg-[#f5faf7] !tw-border-l-4 !tw-border-l-ieo-green' : ''" [class.p-join-top]="item.isJoinedToPrevious" [class.p-join-bottom]="item.isJoinedToNext"> </mat-row> 
        </mat-table>
      </div>
    </div>

    <!-- Mobile cards -->
    <!-- Single entries use their own newlyImported flag.
    For a group, if any child is newlyImported, mark the group as newlyImported.
    -->
    <div class="tw-space-y-4 md:tw-hidden" *ngIf="!provisional && groupedTree.length > 0">
      <div
        *ngFor="let group of groupedTree"
        [ngClass]="'tw-rounded-lg tw-border'+(group.node?.newlyImported ? ' !tw-border-[#c8e9d6] !tw-border-l-4 !tw-border-l-ieo-green tw-bg-[#f5faf7]' : ' tw-border-divider')"
      >
        <!-- Company header (collapsible) -->
        <button
          type="button"
          class="tw-flex tw-w-full tw-items-center tw-justify-between tw-gap-2.5 tw-px-4 tw-py-3 tw-text-left tw-bg-transparent"
          (click)="group.node.isCollapsed = !group.node.isCollapsed"
        >
          <div class="tw-min-w-0 tw-flex-1">
            <app-thumbnail-group
              [name]="group.node?.company?.brandName"
              [description]="
                group.children.length > 0
                  ? counterList(group.children)
                  : group.node?.tickerCode || group.node?.company?.name
              "
              [imageUrl]="group.node?.company?.companyLogoUrl"
            >
            </app-thumbnail-group>
          </div>

          <div class="tw-flex tw-shrink-0 tw-items-center tw-gap-2.5">
            <!-- Buy more (single company only) -->
            <a
              *ngIf="
                group.children.length === 0 &&
                group.node?.tickerCode &&
                group.node?.status !== ShareMarketStatus.Dehosting &&
                group.node?.status !== ShareMarketStatus.Inactive
              "
              [routerLink]="['/pstx', group.node?.tickerCode]"
              (click)="$event.stopPropagation()"
              class="btn btn-black-border btn-md"
            >
              {{ 'mysec.buyMore' | translate }}
            </a>

            <span
              class="tw-inline-block tw-origin-center tw-transform tw-transition-transform"
              [class.tw-rotate-180]="!group.node.isCollapsed"
            >
              <p-icon name="chevron-down"></p-icon>
            </span>
          </div>
        </button>

        <!-- Body -->
        <div [ngbCollapse]="group.node.isCollapsed">
          <div>
            <hr class="tw-mx-4 tw-my-0" />

            <!-- Company / aggregate summary -->
            <ng-container
              *ngTemplateOutlet="mobileMetrics; context: { item: group.node }"
            ></ng-container>

            <!-- Single company footer -->
            <ng-container *ngIf="group.children.length === 0">
              <ng-container
                *ngTemplateOutlet="mobileFooter; context: { item: group.node }"
              ></ng-container>
            </ng-container>

            <!-- Aggregate: nested counter cards -->
            <div *ngIf="group.children.length > 0" class="tw-space-y-3 tw-px-4 tw-pb-4">
              <div
                *ngFor="let child of group.children"
                [ngClass]="'tw-rounded-lg '+(child.newlyImported ? 'tw-border !tw-border-[#c8e9d6] !tw-border-l-4 !tw-border-l-ieo-green tw-bg-[#f5faf7]' : 'tw-bg-divider-light')"
              >
                <!-- Counter header -->
                <div
                  class="tw-flex tw-items-center tw-justify-between tw-gap-2.5 tw-px-4 tw-py-3"
                >
                  <div class="tw-flex tw-min-w-0 tw-flex-1 tw-items-center tw-gap-2.5">
                    <div class="p-skeleton-image tw-h-10 tw-w-10 tw-flex-shrink-0">
                      <img
                        class="logo-image tw-h-10 tw-w-10 tw-flex-shrink-0 tw-border tw-border-solid tw-border-divider !tw-object-cover !tw-shadow-none"
                        [alt]="child?.tickerCode"
                        [src]="child?.company?.companyLogoUrl || DefaultLogo"
                      />
                    </div>
                    <div class="tw-min-w-0">
                      <div class="tw-line-clamp-1 tw-text-xs tw-text-body tw-text-opacity-70">
                        {{ group.node?.company?.brandName }}
                      </div>
                      <div class="tw-line-clamp-1 tw-font-bold tw-uppercase tw-text-black">
                        {{ child?.tickerCode }}
                      </div>
                    </div>
                  </div>

                  <a
                    *ngIf="
                      child?.tickerCode &&
                      child?.status !== ShareMarketStatus.Dehosting &&
                      child?.status !== ShareMarketStatus.Inactive
                    "
                    [routerLink]="['/pstx', child?.tickerCode]"
                    class="btn btn-black-border btn-md tw-shrink-0"
                  >
                    {{ 'mysec.buyMore' | translate }}
                  </a>
                </div>

                <ng-container
                  *ngTemplateOutlet="mobileMetrics; context: { item: child }"
                ></ng-container>
                <ng-container
                  *ngTemplateOutlet="mobileFooter; context: { item: child }"
                ></ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Pagination (PstxPagination — matches the Orders page. Hidden while searching,
         since search filters within the loaded page. Controls always render otherwise,
         staying disabled at the boundaries.) -->
    <div class="tw-mt-8" *ngIf="companyCount > 0 && !searchTerm?.trim()">
      <pstx-pagination
        [currentPage]="currentPage"
        [totalItems]="companyCount"
        [pageSize]="pageSize"
        [itemLabel]="'portfolio.companiesLabel' | translate"
        (pageChange)="onPageChange($event)"
      ></pstx-pagination>
    </div>
  </ng-container>
  <ng-container *ngIf="provisional">
      <ng-template *ngTemplateOutlet="noSharesProvisional"></ng-template>
  </ng-container>
  <ng-container *ngIf="!provisional && (!portfolioListModel || portfolioListModel.length == 0)">
    <ng-template *ngTemplateOutlet="noShares"></ng-template>
  </ng-container>
</div>
<agmo-loading *ngIf="isLoading"></agmo-loading>

<ng-template #empty>-</ng-template>
<ng-template #noSharesProvisional>
  <!-- placeholder image-->
  <img src="assets/img/pstx/link_shareholdings_pending_ekyc.png" alt="No shares linked" class="tw-mb-12 tw-block tw-mx-auto" />
  <h4 class="text-center p-text-h4">{{ 'portfolio.noSharesLinked.title' | translate }}</h4>
  <p class="text-center">
    {{ 'portfolio.noSharesLinked.body1' | translate }}<br>{{ 'portfolio.noSharesLinked.body2' | translate }}
  </p>
  <button class="btn tw-block tw-mx-auto text-center tw-rounded-full tw-border-primary tw-bg-white tw-text-primary btn-md tw-w-fit">{{ 'portfolio.noSharesLinked.button' | translate }}</button>
</ng-template>
<ng-template #noShares>
  <div class="col-12 text-center tw-py-20">
    {{ 'common.noRecord' | translate }}
  </div>
</ng-template>

<ng-template #shareQty let-item="item">
  <span *ngIf="item.isAggregate" class="tw-font-medium">{{
    item.portfolio?.shareQuantity | number
  }}</span>
  <button
    *ngIf="!item.isAggregate"
    class="p-link-secondary tw-p-0 tw-font-medium"
    (click)="openShare(item)"
  >
    {{ item.portfolio?.shareQuantity | number }}
  </button>
</ng-template>

<ng-template #marketPrice let-item="item">
  <div class="text-black tw-whitespace-nowrap md:max-xl:tw-whitespace-normal md:max-xl:tw-text-xs">
    {{ item.portfolio?.marketPrice | numberSuffix: { numberFormat: '1.2-2' } || '-' }}
  </div>
</ng-template>

<ng-template #investmentAmount let-item="item">
  <div class="text-black tw-whitespace-nowrap md:max-xl:tw-whitespace-normal md:max-xl:tw-text-xs">
    {{
      (item.portfolio?.costBasis ?? item.portfolio?.purchasedAmount)
        | numberSuffix: { numberFormat: '1.2-2' }
    }}
  </div>
</ng-template>

<!-- Mobile: 2-column metric grid (share qty, inv. amount, indicative amount, total gain/loss) -->
<ng-template #mobileMetrics let-item="item">
  <div class="tw-px-4 tw-py-3">
    <div class="tw-grid tw-grid-cols-2 tw-items-start tw-gap-x-4 tw-gap-y-3">
      <!-- Share qty -->
      <div>
        <div class="overview-label">{{ 'portfolio.shareQty' | translate }}</div>
        <div class="overview-value !tw-font-normal">
          <ng-container *ngTemplateOutlet="shareQty; context: { item: item }"></ng-container>
        </div>
      </div>

      <!-- Inv. amount -->
      <div>
        <div class="overview-label !tw-flex tw-items-center">
          {{ 'portfolio.invAmount' | translate }}
          <button
            type="button"
            #tooltipInvest="matTooltip"
            (click)="tooltipInvest.toggle()"
            class="btn-transparent !tw-pr-0"
            matTooltip="{{ 'portfolio.investedAmountTooltip' | translate }}"
          >
            <div class="pitchin-icon pitchin-icon-help-circle p-help-icon"></div>
          </button>
        </div>
        <div class="overview-value !tw-font-normal">
          <ng-container *ngTemplateOutlet="investmentAmount; context: { item: item }"></ng-container>
        </div>
      </div>

      <!-- Indicative amount -->
      <div>
        <div class="overview-label !tw-flex tw-items-center">
          {{ 'portfolio.indicativeAmount' | translate }}
          <button
            type="button"
            #tooltipMarket="matTooltip"
            (click)="tooltipMarket.toggle()"
            class="btn-transparent !tw-pr-0"
            matTooltip="{{ 'portfolio.totalMarketValueTooltip' | translate }}"
          >
            <div class="pitchin-icon pitchin-icon-help-circle p-help-icon"></div>
          </button>
        </div>
        <div class="overview-value !tw-font-normal">
          <ng-container *ngTemplateOutlet="marketPrice; context: { item: item }"></ng-container>
        </div>
        <!-- PLT-1394 hide valuation basis when counter is pending or dehosted, also if no new updatedPrice, don't show -->
        <div
          class="tw-mt-0.5"
          *ngIf="
            !item.isAggregate &&
            item.tickerCode &&
            item.status !== ShareMarketStatus.Dehosting &&
            item.portfolio?.indicativeSharePrice !== 0 &&
            item.portfolio?.valuationBasis !== undefined
          "
        >
          <button
            type="button"
            class="p-link-secondary tw-text-xs"
            (click)="openValuationBasisPopup(item)"
          >
            {{ 'mysec.valuationBasis' | translate }} →
          </button>
        </div>
      </div>

      <!-- Total gain/loss -->
      <div>
        <div class="overview-label !tw-flex tw-items-center">
          {{ 'portfolio.totalGainLoss' | translate }}
          <button
            type="button"
            #tooltipGain="matTooltip"
            (click)="tooltipGain.toggle()"
            class="btn-transparent !tw-pr-0"
            matTooltip="{{ 'portfolio.unrealisedGainLossTooltip' | translate }}"
          >
            <div class="pitchin-icon pitchin-icon-help-circle p-help-icon"></div>
          </button>
        </div>
        <div class="overview-value !tw-font-normal">
          <ng-container *ngTemplateOutlet="mobileGainLoss; context: { item: item }"></ng-container>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<!-- Mobile: total gain/loss headline + unrealised/realised breakdown -->
<ng-template #mobileGainLoss let-item="item">
  <ng-container *ngIf="item?.portfolio; else empty">
    <div class="tw-flex tw-flex-wrap tw-items-center tw-gap-2">
      <span
        [ngClass]="
          totalGainLoss(item) > 0
            ? 'text-success'
            : totalGainLoss(item) < 0
              ? 'text-primary'
              : 'text-light-grey'
        "
      >
        {{ totalGainLoss(item) > 0 ? '+' : totalGainLoss(item) < 0 ? '-' : '' }}
        {{
          (totalGainLoss(item) < 0 ? -1 * totalGainLoss(item) : totalGainLoss(item))
            | numberSuffix: { numberFormat: '1.2-2' }
        }}
      </span>
      <span
        class="p-text-tag--round"
        *ngIf="totalGainLossPercentage(item) !== 0"
        [class.p-tag--error]="totalGainLossPercentage(item) < 0"
        [class.p-tag--success]="totalGainLossPercentage(item) > 0"
      >
        <span
          class="fa tw-mr-1"
          [class.fa-arrow-up]="totalGainLossPercentage(item) > 0"
          [class.fa-arrow-down]="totalGainLossPercentage(item) < 0"
        >
        </span>
        {{
          (totalGainLossPercentage(item) < 0
            ? totalGainLossPercentage(item) * -1
            : totalGainLossPercentage(item)
          ) | number: '1.0-0'
        }}%
      </span>
    </div>

    <!-- Unrealised / realised breakdown -->
    <div *ngIf="hasGainBreakdown(item)" class="tw-mt-1.5 tw-space-y-0.5 tw-text-xs">
      <div class="tw-flex tw-justify-between tw-gap-2">
        <span class="tw-text-body">{{ 'portfolio.unrealised' | translate }}</span>
        <span
          class="tw-min-w-0 tw-text-right tw-tabular-nums"
          [ngClass]="
            item.portfolio.unrealisedGainLoss > 0
              ? 'text-success'
              : item.portfolio.unrealisedGainLoss < 0
                ? 'text-primary'
                : 'text-light-grey'
          "
        >
          {{
            item.portfolio.unrealisedGainLoss > 0
              ? '+'
              : item.portfolio.unrealisedGainLoss < 0
                ? '-'
                : ''
          }}
          {{
            (item.portfolio.unrealisedGainLoss < 0
              ? -1 * item.portfolio.unrealisedGainLoss
              : item.portfolio.unrealisedGainLoss
            ) | numberSuffix: { numberFormat: '1.2-2' }
          }}
        </span>
      </div>
      <div class="tw-flex tw-justify-between tw-gap-2" *ngIf="hasRealised(item)">
        <span class="tw-text-body">{{ 'portfolio.realised' | translate }}</span>
        <span
          class="tw-min-w-0 tw-text-right tw-tabular-nums"
          [ngClass]="
            item.portfolio.realisedGainLoss > 0
              ? 'text-success'
              : item.portfolio.realisedGainLoss < 0
                ? 'text-primary'
                : 'text-light-grey'
          "
        >
          {{
            item.portfolio.realisedGainLoss > 0
              ? '+'
              : item.portfolio.realisedGainLoss < 0
                ? '-'
                : ''
          }}
          {{
            (item.portfolio.realisedGainLoss < 0
              ? -1 * item.portfolio.realisedGainLoss
              : item.portfolio.realisedGainLoss
            ) | numberSuffix: { numberFormat: '1.2-2' }
          }}
        </span>
      </div>
    </div>
  </ng-container>
</ng-template>

<!-- Mobile: card footer actions (view company + digital cert) -->
<ng-template #mobileFooter let-item="item">
  <hr class="tw-mx-4 tw-my-0" />

  <div class="tw-flex tw-gap-3 tw-px-4 tw-py-3">
    <!-- View company shows on every counter, matching the desktop Actions column:
         a counter with a ticker opens the PSTX Market tab unless it is Dehosting
         or Inactive (Halt and Suspend still route there). Everything else — no
         ticker, dehosted, inactive — falls back to the company page. -->
    <div class="tw-min-w-0 tw-flex-1">
      <a
        *ngIf="
          item.tickerCode &&
          item.status !== ShareMarketStatus.Dehosting &&
          item.status !== ShareMarketStatus.Inactive
        "
        [routerLink]="['/pstx', item.tickerCode]"
        class="btn btn-black-border btn-md tw-w-full !tw-whitespace-normal tw-px-2 tw-leading-tight"
      >
        {{ 'portfolio.viewCompany' | translate }}
      </a>
      <a
        *ngIf="
          !(
            item.tickerCode &&
            item.status !== ShareMarketStatus.Dehosting &&
            item.status !== ShareMarketStatus.Inactive
          )
        "
        [routerLink]="['/company']"
        [queryParams]="{ companyId: item.portfolio?.companyId }"
        class="btn btn-black-border btn-md tw-w-full !tw-whitespace-normal tw-px-2 tw-leading-tight"
      >
        {{ 'portfolio.viewCompany' | translate }}
      </a>
    </div>

    <div class="tw-min-w-0 tw-flex-1" *ngIf="item.digitalCert && item.digitalCert?.url">
      <button
        type="button"
        class="btn btn-black-border btn-md tw-w-full !tw-whitespace-normal tw-px-2 tw-leading-tight"
        (click)="openUrl(item.digitalCert?.url)"
      >
        {{ 'portfolio.downloadDigitalCert' | translate }}
      </button>
    </div>
  </div>
</ng-template>

<!-- Desktop gain/loss: percentage + amount, with an expandable unrealised/realised
     breakdown. Realised + combined total stay hidden until the API exposes them. -->
<ng-template #gainLossDesktop let-item="item">
  <ng-container
    *ngIf="
      item?.portfolio &&
        (item?.portfolio?.unrealisedGainLoss || item?.portfolio?.unrealisedGainLoss == 0);
      else empty
    "
  >
    <!-- Headline: percentage badge above the total gain/loss amount (stacked) -->
    <div class="tw-flex tw-flex-col tw-items-end tw-gap-1">
      <span
        class="p-text-tag--round"
        *ngIf="totalGainLossPercentage(item) !== 0"
        [class.p-tag--error]="totalGainLossPercentage(item) < 0"
        [class.p-tag--success]="totalGainLossPercentage(item) > 0"
      >
        <span
          class="fa tw-mr-1"
          [class.fa-arrow-up]="totalGainLossPercentage(item) > 0"
          [class.fa-arrow-down]="totalGainLossPercentage(item) < 0"
        >
        </span>
        {{
          (totalGainLossPercentage(item) < 0
            ? totalGainLossPercentage(item) * -1
            : totalGainLossPercentage(item)
          ) | number: '1.0-0'
        }}%
      </span>
      <span
        class="tw-whitespace-nowrap tw-tabular-nums"
        [ngClass]="
          totalGainLoss(item) > 0
            ? 'text-success'
            : totalGainLoss(item) < 0
              ? 'text-primary'
              : 'text-light-grey'
        "
      >
        {{ totalGainLoss(item) > 0 ? '+' : totalGainLoss(item) < 0 ? '-' : '' }}
        {{
          (totalGainLoss(item) < 0 ? -1 * totalGainLoss(item) : totalGainLoss(item))
            | numberSuffix: { numberFormat: '1.2-2' }
        }}
      </span>
    </div>

    <!-- Unrealised / realised breakdown — always shown (per design) -->
    <div
      *ngIf="hasGainBreakdown(item)"
      class="tw-mt-1.5 tw-w-full tw-rounded-[10px] tw-bg-divider-light tw-p-3 tw-text-xs"
    >
      <div class="tw-flex tw-items-center tw-justify-between tw-gap-2 max-xl:tw-flex-wrap">
        <span class="tw-text-body">{{ 'portfolio.unrealised' | translate }}</span>
        <span
          class="tw-whitespace-nowrap tw-text-right tw-tabular-nums max-xl:tw-whitespace-normal max-xl:tw-text-left"
          [ngClass]="
            item.portfolio.unrealisedGainLoss > 0
              ? 'text-success'
              : item.portfolio.unrealisedGainLoss < 0
                ? 'text-primary'
                : 'text-light-grey'
          "
        >
          {{
            item.portfolio.unrealisedGainLoss > 0
              ? '+'
              : item.portfolio.unrealisedGainLoss < 0
                ? '-'
                : ''
          }}
          {{
            (item.portfolio.unrealisedGainLoss < 0
              ? -1 * item.portfolio.unrealisedGainLoss
              : item.portfolio.unrealisedGainLoss
            ) | numberSuffix: { numberFormat: '1.2-2' }
          }}
        </span>
      </div>

      <!-- Realised: shown only once portfolio.realisedGainLoss is populated -->
      <div
        class="tw-mt-1 tw-flex tw-items-center tw-justify-between tw-gap-2 max-xl:tw-flex-wrap"
        *ngIf="
          item.portfolio.realisedGainLoss !== undefined &&
          item.portfolio.realisedGainLoss !== null
        "
      >
        <span class="tw-text-body">{{ 'portfolio.realised' | translate }}</span>
        <span
          class="tw-whitespace-nowrap tw-text-right tw-tabular-nums max-xl:tw-whitespace-normal max-xl:tw-text-left"
          [ngClass]="
            item.portfolio.realisedGainLoss > 0
              ? 'text-success'
              : item.portfolio.realisedGainLoss < 0
                ? 'text-primary'
                : 'text-light-grey'
          "
        >
          {{
            item.portfolio.realisedGainLoss > 0
              ? '+'
              : item.portfolio.realisedGainLoss < 0
                ? '-'
                : ''
          }}
          {{
            (item.portfolio.realisedGainLoss < 0
              ? -1 * item.portfolio.realisedGainLoss
              : item.portfolio.realisedGainLoss
            ) | numberSuffix: { numberFormat: '1.2-2' }
          }}
        </span>
      </div>
    </div>
  </ng-container>
</ng-template>
